import React from 'react';
import { Text } from '@mantine/core';
import _ from 'lodash';

import { RequestsPerCategory } from '../../codegen/graphql';

type Props = {
    requestsPerCategory: RequestsPerCategory[];
};

function RequestsPerCategoryGraph({ requestsPerCategory }: Props) {
    const sortedRequestsPerCategory = _.orderBy(
        requestsPerCategory,
        ['totalRequests'],
        ['desc'],
    );

    return sortedRequestsPerCategory.length > 0 ? (
        <div className="flex flex-1 h-full w-full relative">
            <div className="rounded-full bg-[#F09646] max-w-[200px] lg:max-w-[220px] w-full aspect-square absolute flex items-center justify-center left-[50%] translate-x-[-60%] top-[50%] translate-y-[-75%]">
                <div>
                    <Text className="whitespace-nowrap overflow-hidden text-ellipsis font-medium text-white">
                        {sortedRequestsPerCategory[0]?.category?.name}
                    </Text>
                    <Text className="text-xl font-bold text-center text-white">
                        {sortedRequestsPerCategory[0]?.totalRequests}
                    </Text>
                </div>
                <div className="rounded-full bg-[#2A5EA7] max-w-[120px] w-full aspect-square absolute flex items-center justify-center -bottom-20">
                    <div>
                        <Text className="whitespace-nowrap overflow-hidden text-ellipsis font-medium text-white">
                            {sortedRequestsPerCategory[2]?.category?.name}
                        </Text>
                        <Text className="text-xl font-bold text-center text-white">
                            {sortedRequestsPerCategory[2]?.totalRequests}
                        </Text>
                    </div>
                </div>

                <div className="rounded-full bg-[#A5D8FF] max-w-[120px] lg:max-w-[140px] w-full aspect-square absolute flex items-center justify-center -right-10 lg:-right-14 -bottom-6 lg:-bottom-6">
                    <div>
                        <Text className="whitespace-nowrap overflow-hidden text-ellipsis font-medium text-primary">
                            {sortedRequestsPerCategory[1]?.category?.name}
                        </Text>
                        <Text className="text-xl font-bold text-center text-primary">
                            {sortedRequestsPerCategory[1]?.totalRequests}
                        </Text>
                    </div>
                </div>

                <div className="rounded-full bg-[#FFE066] max-w-[120px] w-full aspect-square absolute flex items-center justify-center top-5 -right-20">
                    <div>
                        <Text className="whitespace-nowrap overflow-hidden text-ellipsis font-medium text-primary text-sm">
                            {sortedRequestsPerCategory[3]?.category?.name}
                        </Text>
                        <Text className="text-xl font-bold text-center text-primary">
                            {sortedRequestsPerCategory[3]?.totalRequests}
                        </Text>
                    </div>
                </div>
            </div>
        </div>
    ) : (
        <div className="flex justify-center items-center h-96 pb-[120px]">
            No requests per category
        </div>
    );
}

export default RequestsPerCategoryGraph;
